<template>
    <div class="mainbusinessModuleWarp">
        <div  class="moduleTitle">人才测评服务</div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <div class="bigTitle">一、从业人员</div>
                    <el-form-item label="  1.从业人员总数：" prop="1">
                        <el-input v-model="ruleForm[1]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  2.本科及以上学历比例（%）：" prop="2">
                        <el-input v-model="ruleForm[2]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="3.具备应用测评工具和方法的专业技能：" prop="3">
                        <el-radio-group v-model="ruleForm[3]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="4.能够确保测评过程和结果的保密：" prop="4">
                        <el-radio-group v-model="ruleForm[4]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="5.评测工作负责人具有本科及以上学历：" prop="5">
                        <el-radio-group v-model="ruleForm[5]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="  6.研究生学历或硕士以上学位比例（%）：" prop="6">
                        <el-input v-model="ruleForm[6]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="7.测评工作负责人具有研究生及以上学历：" prop="7">
                        <el-radio-group v-model="ruleForm[7]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="8.测评工作负责人具有硕士及以上学位：" prop="8">
                        <el-radio-group v-model="ruleForm[8]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="9.有稳定的测评专家队伍：" prop="9">
                        <el-radio-group v-model="ruleForm[9]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="10.具有测评专家库：" prop="10">
                        <el-radio-group v-model="ruleForm[10]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">二、服务场所</div>
                    <el-form-item label=" 11.服务场所建筑面积（平米）：" prop="11">
                        <el-input v-model="ruleForm[11]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="12.有独立的测评室：" prop="12">
                        <el-radio-group v-model="ruleForm[12]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="  13.独立测评室面积（平米）：" prop="13">
                        <el-input v-model="ruleForm[13]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="14.有顾客等候和休息场所：" prop="14">
                        <el-radio-group v-model="ruleForm[14]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">三、业务范围</div>
                    <el-form-item label=" 15.在本地区或本行业独立开展测评业务数量（项）：" prop="15">
                        <el-input v-model="ruleForm[15]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="16.测评的人群和项目具有一定的广泛性：" prop="16">
                        <el-radio-group v-model="ruleForm[16]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 17.除本地区、本行业测评服务外，对外承担的测评业务量占业务总量比例（%）：" prop="17">
                        <el-input v-model="ruleForm[17]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">四、测评工具</div>
                    <el-form-item label=" 18.运用的测评工具数量：" prop="18">
                        <el-input v-model="ruleForm[18]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="19.能够自主开发测评软件并投入使用：" prop="19">
                        <el-radio-group v-model="ruleForm[19]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="20.具有专业测评题库：" prop="20">
                        <el-radio-group v-model="ruleForm[20]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="21.自主开发测评软件并向社会推广应用：" prop="21">
                        <el-radio-group v-model="ruleForm[21]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="22.具有完善的测评服务体系：" prop="22">
                        <el-radio-group v-model="ruleForm[22]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">五、测评项目</div>
                    <el-form-item label="23.年测评项目数：" prop="23">
                        <el-input v-model="ruleForm[23]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="24.年测评人数：" prop="24">
                        <el-input v-model="ruleForm[24]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="25.受测高级人才比例（%）：" prop="25">
                        <el-input v-model="ruleForm[25]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">六、信息化管理程度</div>
                    <el-form-item label="26.测评业务管理手工操作：" prop="26">
                        <el-radio-group v-model="ruleForm[26]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="27.测评业务实行计算机操作：" prop="27">
                        <el-radio-group v-model="ruleForm[27]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="28.部分业务可实现信息化管理：" prop="28">
                        <el-radio-group v-model="ruleForm[28]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="29.具有测评业务信息化管理软件：" prop="29">
                        <el-radio-group v-model="ruleForm[29]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="30.主要业务实现信息化管理：" prop="30">
                        <el-radio-group v-model="ruleForm[30]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="31.建立测评业务信息化管理系统：" prop="31">
                        <el-radio-group v-model="ruleForm[31]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="32.实现服务全过程信息化管理：" prop="32">
                        <el-radio-group v-model="ruleForm[32]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">七、材料归档</div>
                    <el-form-item label="33.材料归档率达（%）：" prop="33">
                        <el-input v-model="ruleForm[33]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">八、客户投诉记录及处理</div>
                    <el-form-item label="34.是否设有投诉电话：" prop="34">
                        <el-radio-group v-model="ruleForm[34]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="35.接到投诉到介入处理再到反馈当事人处理结果所需时间（天）：" prop="35">
                        <el-input v-model="ruleForm[35]" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label="  36.是否有投诉及处理情况记录" prop="36">
                        <el-radio-group v-model="ruleForm[36]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="37.投诉及处理情况记录保存年限（年）：" prop="37">
                        <el-input v-model="ruleForm[37]" placeholder="请输入"></el-input>
                    </el-form-item>

                </div>
                <div class="dialogformBottomBtnBox" v-if="!result">
                    <el-button type="primary" @click="saveForm" class="submitBtn">保存</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
            </el-form>

        </div>
    </div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
    props: ['saveId', 'result'],
    data() {
        return {
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                24: '',
                25: '',
                26: '',
                27: '',
                28: '',
                29: '',
                30: '',
                31: '',
                32: '',
                33: '',
                34: '',
                35: '',
                36: '',
                37: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },

                ],
                2: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],

                3: [
                    { required: true, message: '请选择', trigger: 'change' },

                ],
                4: [
                    { required: true, message: '请选择', trigger: 'change' },

                ],
                // 小数
                5: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                6: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                7: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                8: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                // 多选
                9: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                10: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                11: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                12: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                13: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                14: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                15: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                16: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                17: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                18: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                19: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                20: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                21: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                22: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                23: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                24: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                25: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                26: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                27: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                28: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                29: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                30: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                31: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                32: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                33: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                34: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                35: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                36: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                37: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],

            },
        }
    },
    created() {
        this.yetData()
    },
    methods: {
        saveForm() {
            let NewDataList = []
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.saveB(this.saveId, NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit('getyetServiceFn')
                }
            })
        },
        // 提交
        submitForm(formName) {
            // 保存不通过validate检验
            this.$refs[formName].validate((valid, obj) => {
                if (valid) {

                    let NewDataList = []
                    for (const key in this.ruleForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = this.ruleForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScore(this.saveId,NewDataList).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$emit('getyetServiceFn')
                        }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },

        cancelForm() {
            this.$emit('getyetServiceFn')
        },
        // 回填表单数据
        yetData() {
              httpService.getCorpIndicatorOption(this.saveId).then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                    }
                }
            })
        },
    }


}
</script>
<style lang="less" scoped>
.mainbusinessModal5Warp {
}
</style>


